module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/e420f1d3387b0426a7d0ce0cc831dc26.svg";